var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconHistoryBack = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-35.395 -727.41)" },
                React.createElement("g", { transform: "translate(35.843 725.24)" },
                    React.createElement("path", { d: "M3.7,8.5V15h6.5" }),
                    React.createElement("path", { d: "M6.4,20.4c1.8,5.1,7.4,7.7,12.4,6c5.1-1.8,7.7-7.4,6-12.4C23,8.9,17.5,6.2,12.4,8\n\t\t\tC11,8.5,9.8,9.2,8.7,10.3l-5,4.7" })),
                React.createElement("g", { transform: "translate(35.833 727.333)" },
                    React.createElement("path", { d: "M14.8,10.3v6l4,2" }))))));
});
export default IconHistoryBack;
//# sourceMappingURL=IconHistoryBack.js.map